import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=9eb97e1a&scoped=true"
import script from "./bar-chart.vue?vue&type=script&lang=js"
export * from "./bar-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb97e1a",
  null
  
)

export default component.exports